import {Language} from './i18nTypes';

// @ts-ignore
let backendUrl = window.BACKEND_URL;

if (!backendUrl && window.location.host !== 'localhost:3000') {
    const url = new URL(window.location.href);
    url.port = '8080';
    backendUrl = url.href;
}
export const BACKEND_URL = backendUrl;
// @ts-ignore
export const PUBLIC_URL = window.PUBLIC_URL || '/app';

export const SEARCH_PATH = '/search';

// @ts-ignore
export const DEFAULT_LANGUAGE = window.DEFAULT_LANGUAGE || Language.GERMAN;
// @ts-ignore
export const CONTAINER_VERSION = window.CONTAINER_VERSION || 'n/a';

// @ts-ignore
console.log('PUBLIC_URL', PUBLIC_URL);
console.log('BACKEND_URL', BACKEND_URL);
